export type SupportedEnvironments = 'stage' | 'beta'

export enum SupportedEnv {
  STAGE = 'stage',
  BETA = 'beta',
}
